export const MENU_IDS = {
  FEATURES: "features",
  PRODUCTS: "products",
};
